import { render } from "./device-details-events.vue?vue&type=template&id=923dc134&ts=true"
import script from "./device-details-events.ts?vue&type=script&lang=ts"
export * from "./device-details-events.ts?vue&type=script&lang=ts"

import "./device-details-events.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__